import * as React from 'react';
import { translate } from 'react-i18next';
import { InjectedFormProps, Field } from 'redux-form';
import * as c from 'models/constants';
import { IImageData } from 'models/common';
import { IModalAction } from 'models/modal';
import { IPortalPageSection } from 'models/portal/page/portalpagesection';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { IArticleCard } from 'models/magazine/article/articlecard';
import { ImageUpload, PortalInputField } from 'components/FormControls';
import { PortalPageSection } from 'components/PortalStructure';
import { required } from 'helpers/validationattributes';
import { WhiteButton } from 'components';
import { isValidUrl } from 'helpers/common';

interface IProps extends InjectedFormProps {
	currentFormValues?: IPortalPageSection;
	section?: IPortalPageSection;
	index?: number;
	baseUrl?: string;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
	change?: (field: any, value: any) => void;
	setError: (error: any) => void;
	clearError: () => void;
	baseUrlClient?: string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ManageSectionItemArticle extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.imageUploadedCallback = this.imageUploadedCallback.bind(this);
		this.imageUploadFailed = this.imageUploadFailed.bind(this);
		this.searchArticle = this.searchArticle.bind(this);
		this.selectArticle = this.selectArticle.bind(this);
		this.deleteImage = this.deleteImage.bind(this);
	}

	public componentDidMount() {
		if (
			this.props.currentFormValues &&
			this.props.currentFormValues.items &&
			!this.props.currentFormValues.items[this.props.index]
		) {
			this.props.change('items[' + this.props.index + '].type', c.PORTAL_PAGE_SECTION_ITEM_ARTICLE);
			this.props.change('items[' + this.props.index + '].elements', []);
			this.props.change('items[' + this.props.index + '].elements[0]', { imageUrl: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[1]', { text: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[2]', { text: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[3]', { text: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[4]', { text: null, redirectUrl: null });
		}
	}

	private imageUploadedCallback(id: string, href: string, additionalData: string[]) {
		this.props.clearError();

		const image: IImageData = {
			id,
			href,
		};

		if (additionalData.length > 0) {
			this.props.change(additionalData[0], image.href);
		}

		this.forceUpdate();
	}

	private imageUploadFailed(error: any) {
		if (error) {
			this.props.setError(error);
			this.forceUpdate();
		}
	}

	private selectArticle(data: IArticleCard) {
		this.props.closeModal();
		this.props.change('items[' + this.props.index + '].type', c.PORTAL_PAGE_SECTION_ITEM_ARTICLE);
		this.props.change(
			'items[' + this.props.index + '].elements[1].redirectUrl',
			this.props.baseUrl + '/magazine/article/' + data.code,
		);
		this.props.change('items[' + this.props.index + '].elements[1].text', data.title);
		this.props.change('items[' + this.props.index + '].elements[2].text', data.addedBy);
		if (data.coverImages && data.coverImages.length) {
			this.props.change('items[' + this.props.index + '].elements[0].imageUrl', data.coverImages[0].href);
		} else {
			this.deleteImage();
		}
		this.props.change(
			'items[' + this.props.index + '].elements[0].redirectUrl',
			this.props.baseUrl + '/magazine/article/' + data.code,
		);
		this.props.change('items[' + this.props.index + '].elements[3].text', data.addedDate);
		this.props.change('items[' + this.props.index + '].elements[4].text', data.userCode);
	}

	private searchArticle(e: any, func: (data: IArticleCard) => void) {
		e.preventDefault();
		this.props.showModal('SearchArticles', {
			selectArticle: func,
			closeModal: this.props.closeModal,
			showHeaderCloseButton: true,
		});
	}

	private deleteImage() {
		this.props.change('items[' + this.props.index + '].elements[0].redirectUrl', null);
		this.props.change('items[' + this.props.index + '].elements[0].imageUrl', null);
		this.forceUpdate();
	}

	////////////////////////////////////
	// Custom validation
	////////////////////////////////////
	private internalURL(value) {
		if (isValidUrl(value) && this.props?.baseUrlClient) {
			const valueOrigin = new URL(value)?.origin;
			if (this.props.baseUrlClient?.includes(valueOrigin)) {
				return undefined;
			} else {
				return this.props?.t('PortalPage_Section_Manage_Common_ExternalLinkError');
			}
		} else {
			if (!value) {
				return undefined;
			}
			return this.props?.t('PortalPage_Section_Manage_Common_InvalidLinkError');
		}
	}
	////////////////////////////////////

	public render() {
		const { t, currentFormValues, index } = this.props;

		return (
			<PortalPageSection usage="admin">
				<div className="row">
					<div className="col-md-12">
						<Field
							name={'items[' + this.props.index + '].elements[0].imageUrl'}
							component={ImageUpload}
							imageUploadedCallback={this.imageUploadedCallback}
							imageUploadFailed={this.imageUploadFailed}
							additionalData={['items[' + this.props.index + '].elements[0].imageUrl']}
							existingImageId={
								currentFormValues &&
								currentFormValues.items &&
								currentFormValues.items.length > 0 &&
								currentFormValues.items[index] &&
								currentFormValues.items[index].elements &&
								currentFormValues.items[index].elements.length > 0 &&
								currentFormValues.items[index].elements[0]
									? (currentFormValues.items[index].elements[0] as ISectionImageElement).imageUrl
									: null
							}
							existingImageUrl={
								currentFormValues &&
								currentFormValues.items &&
								currentFormValues.items.length > 0 &&
								currentFormValues.items[index] &&
								currentFormValues.items[index].elements &&
								currentFormValues.items[index].elements.length > 0 &&
								currentFormValues.items[index].elements[0]
									? (currentFormValues.items[index].elements[0] as ISectionImageElement).imageUrl
									: null
							}
							onDelete={this.deleteImage}
							hideImageInput={true}
							label={t('PortalPage_Section_Manage_Common_Image')}
						/>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12">
						<WhiteButton
							type="submit"
							usage="admin"
							onClick={(event: any) => this.searchArticle(event, this.selectArticle)}
						>
							{t('PortalPage_Section_Manage_Common_SearchArticle')}
						</WhiteButton>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12">
						<Field
							name={'items[' + index + '].elements[1].text'}
							component={PortalInputField}
							usage="admin"
							type="text"
							label={t('PortalPage_Section_Manage_Common_Title')}
							validate={[required]}
						/>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12">
						<Field
							name={'items[' + index + '].elements[0].redirectUrl'}
							component={PortalInputField}
							usage="admin"
							type="text"
							label={t('PortalPage_Section_Manage_Common_RedirectUrl')}
							readonly={true}
							validate={[required, this.internalURL]}
						/>
						<Field name={'items[' + index + '].elements[2].text'} component="input" type="hidden" />
						<Field name={'items[' + index + '].elements[3].text'} component="input" type="hidden" />
					</div>
				</div>
			</PortalPageSection>
		);
	}
}

export { ManageSectionItemArticle };
